import React from 'react';
import { useState } from 'react';
import { FaUser } from "react-icons/fa6";
import logo from '../../images/logo.png';
import { BrowserView, MobileView } from 'react-device-detect';
import { Squeeze as Hamburger } from 'hamburger-react'
import { FaUserGear } from "react-icons/fa6";
import { IoMdLogOut } from "react-icons/io";

import {apiBaseUrl} from '../../core/globalVariables';

const TopMenu = ({
  authClicked,
  openAboutPanel,
  openPrivacyPanel,
  openTacPanel,
  openMobileSignIn,
  globalState,
  closeAuth
}) => {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [user, setUser] = useState(null);

  let workingLocally = globalState.workingLocally;

  let userEmail = globalState.userEmail;
  let loggedInToAPI = globalState.loggedInToAPI;

  let setIsInSettings = globalState.setIsInSettings;
  let setIsInAboutPanel = globalState.setIsInAboutPanel;
  let setIsInInvestorsPanel = globalState.setIsInInvestorsPanel;
  let setIsInPrivacyPanel = globalState.setIsInPrivacyPanel;
  let setIsInTacPanel = globalState.setIsInTacPanel;
  let setLoggedInToAPI = globalState.setLoggedInToAPI;

  let devDeployment = globalState.devDeployment;

  let isLoading = globalState.isLoading;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setOpen(!isOpen);
  };

  // const goToLogin = () => {
  //   if (workingLocally) {
  //     window.location.href = '/api/login';
  //   } else {
  //     if (devDeployment === true) {
  //       window.location.href = 'https://harrierapi9697.site/dev/login';
  //     } else {
  //       window.location.href = 'https://harrierapi9697.site/login';
  //     }
  //   }
  // };

  // 
  // 
  // 

  const goToLogin = async () => {
    const codeVerifier =
      crypto.randomUUID() + crypto.randomUUID();

    const hash = await crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(codeVerifier)
    );

    const codeChallenge = btoa(
      String.fromCharCode(...new Uint8Array(hash))
    )
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');

    const state = crypto.randomUUID();

    sessionStorage.setItem(
      'oauth_code_verifier',
      codeVerifier
    );

    sessionStorage.setItem(
      'oauth_state',
      state
    );

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: 'skylark',
      redirect_uri: 'http://localhost:3000/dev/callback',
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      state,
    });

    window.location.href =
      `${apiBaseUrl}/oauth/authorize?${params}`;
  };

  // 
  // 
  // 

  const handleSignOut = async () => {
    try {
      setUser(null);
      setLoggedInToAPI(false);
      setIsInAboutPanel(false);
      setIsInInvestorsPanel(false);
      setIsInPrivacyPanel(false);
      setIsInTacPanel(false);
      setIsInSettings(false);
      localStorage.setItem('token', null);
      window.location.reload();
    } catch (error) {
      console.error("Sign out failed:", error.message);
    }
  };

  const goToSettings = () => {
    setIsInAboutPanel(false);
    setIsInInvestorsPanel(false);
    setIsInPrivacyPanel(false);
    setIsInTacPanel(false);
    setIsInSettings(true);
    closeAuth();
  };

  return (
    <>
      <div
        className={`top_menu ${isLoading ? 'top_menu_loading' : ''}`}
      >

        <div className='title'>
          <img src={logo} className='logo' alt='Skylark Logo' />
        </div>

        <BrowserView>
          {loggedInToAPI ?
            <>
              <div className='auth_settings' onClick={goToSettings}>
                <p>Account Settings</p>
                <div className="authAccountButton">
                  <FaUserGear />
                </div>
              </div>

              <div className='auth' onClick={handleSignOut}>
                <p>Sign Out</p>
                <div className="authAccountButton">
                  <IoMdLogOut />
                </div>
              </div>
            </>
            :
            <>
              <div className='auth' onClick={goToLogin}>
                <p>Sign in</p>
                <div className="authAccountButton">
                  <FaUser />
                </div>
              </div>
            </>
          }

          <div className='menuItems'>
            <div onClick={openAboutPanel} className='menuItem'>
              About Harrier
            </div>

            <div onClick={openPrivacyPanel} className='menuItem'>
              Privacy
            </div>

            <div onClick={openTacPanel} className='menuItem'>
              Terms & Conditions
            </div>
          </div>
        </BrowserView>

        <MobileView>
          <div className='burgermenu' onClick={toggleMobileMenu}>
            <Hamburger
              className='burgermenuinner'
              color="#29645D"
              size="20"
              toggled={isOpen}
              toggle={setOpen}
            />
          </div>
        </MobileView>

      </div>

      {mobileMenuOpen && (
        <div className="top_menu_Mobile">
          <div onClick={openMobileSignIn} className='menuItemMobile'>
            Account
          </div>

          <div onClick={openAboutPanel} className='menuItemMobile'>
            About Skylark
          </div>

          <div onClick={openPrivacyPanel} className='menuItemMobile'>
            Privacy
          </div>

          <div onClick={openTacPanel} className='menuItemMobile'>
            Terms & Conditions
          </div>
        </div>
      )}
    </>
  );
};

export default TopMenu;